import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// MSW is disabled for store-admin (always use real backend API)
async function enableMocking() {
  return Promise.resolve();
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
  );
});
